import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupText,
  Row,
  Table,
  Button,
} from "reactstrap";
import { get } from "helpers/api_helper";
// import NavLink from "reactstrap/es/NavLink";
import { Link, NavLink, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";

const ViewTemplate = () => {
  const navigate = useNavigate();
  const { tId: id } = useParams();
  console.log("tId",id);
  

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fetchedTemplateData, setFetchedTemplateData] = useState({
    jobId: "",
    jobTitle: "",
    companyName: "",
    jobPostedOn: "",
    department: "",
    payType: "",
    experienceRequired: "",
    numberOfOpenings: "",
    location: "",
    jobExpiryDate: "",
    workType: "",
    salary: "",
    jobDescription: "",
    companyOverview: "",
    whatWeDo: [],
    whyWorkWithUs: [],
    rolesAndResponsibilities: [],
    requiredSkills: [],
    preferredSkills: [],
    educationalQualifications: [],
    salaryRange: "",
    interviewProcess: [],
  });

  const fetchTemplateData = async () => {
    try {
      setLoading(true);

      const response = await get(`recruitment/api/template/getById/${id}`);
      // console.log("response", response);

      const templateData = response?.data;
      // console.log(templateData);
      // Adjust based on actual response structure
      if (!templateData) throw new Error("No template data found");

      setFetchedTemplateData({
        jobId: templateData?.templateId || "",
        jobTitle: templateData?.jobTitle || "",
        companyName: templateData?.company || "", // Not in response, using fallback
        jobPostedOn: "", // Not in response, using fallback
        department: templateData?.department || "",
        payType: templateData?.payType || "",
        experienceRequired: templateData?.experienceRequired || "",
        numberOfOpenings: "", // Not in response, using fallback
        location: "", // Not in response, using fallback
        jobExpiryDate: "", // Not in response, using fallback
        workType: templateData?.workType || "",
        salary: "", // Not in response, using fallback
        jobDescription: templateData?.jobDescription || "",
        companyOverview: templateData?.companyOverview || "",
        whatWeDo: [], // Not in response, using fallback
        whyWorkWithUs: templateData?.perksAndBenefits
          ? [templateData.perksAndBenefits]
          : [],
        rolesAndResponsibilities: templateData?.rolesResponsibilities
          ? [templateData.rolesResponsibilities]
          : [],
        requiredSkills: templateData?.requiredSkills
          ? templateData.requiredSkills?.join(", ")
          : [],
        preferredSkills: templateData?.preferredSkills
          ? templateData.preferredSkills?.join(", ")
          : [],
        educationalQualifications: templateData?.educationalQualification
          ? [templateData.educationalQualification]
          : [],
        salaryRange: templateData?.salaryRange || "",
        interviewProcess: templateData?.interviewStages || [],
      });
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // console.log("useEffect triggered with id:", id); // Debug useEffect
    fetchTemplateData();
  }, []);

  return (
    <div className="page-content">
      <Container fluid className="py-0 px-0">
        <PageSubHeader
          heading={"View Template"}
          routePath={"Home"}
          pageName={"Templates/ Template 1/ View Template"}
        />
        <Row className="px-4 py-4">
          {/* <Row className="py-2 px-4">
            <p className="sub-heading">Templates/ Template 1/ mplate</p>
            <h2 className="heading">View Template</h2>
          </Row> */}

          {/* <Row className="d-flex justify-content-end">
            <Button
              style={{
                backgroundColor: "#006438",
                color: "#FFFFFF",
                borderRadius: "12px",
                width: "168px",
              }}
            >
              Edit Template
            </Button>
          </Row> */}

          <Row className=" pe-4 mt-4">
            <Row className="  p-3 m-4 mt-1  data">
              <Col size={6}>
                <p className="info-head">Template ID</p>
                <p className="info">{fetchedTemplateData.jobId}</p>
                <p className="info-head">Department</p>
                <p className="info">{fetchedTemplateData.department}</p>
                <p className="info-head">Work Type</p>
                <p className="info">{fetchedTemplateData.workType}</p>
                <p className="info-head">Salary</p>
                <p className="info">{fetchedTemplateData.salaryRange}</p>

                {/* <p className="info-head">Company Name</p>
                <p className="info">{fetchedTemplateData.companyName}</p>
                <p className="info-head">Job Posted On</p>
                <p className="info"></p>
               
                <p className="info-head">Pay Type</p>
                <p className="info">{fetchedTemplateData.payType}</p> */}
              </Col>
              <Col size={6}>
                <p className="info-head">Job Title</p>
                <p className="info">{fetchedTemplateData.jobTitle}</p>
                <p className="info-head">Experience Required</p>
                <p className="info">{fetchedTemplateData.experienceRequired}</p>
                <p className="info-head">Pay Type</p>
                <p className="info">{fetchedTemplateData.payType}</p>
                {/* <p className="info-head">Number of Openings</p>
                <p className="info"></p>
                <p className="info-head">Location</p>
                <p className="info"></p>
                <p className="info-head">Job Expiry Date</p>
                <p className="info"></p> */}
              </Col>
            </Row>
            <Row className="  p-3 m-4 mt-1 data">
              <p className="info-head">Job Description</p>
              <p className="info">{fetchedTemplateData.jobDescription}</p>
            </Row>
            <Row className="  p-3 m-4 mt-1  data">
              <p className="info-head">Company Overview</p>
              <p className="info">{fetchedTemplateData.companyOverview}</p>

              {/* <p className="info-head">What We Do?</p>
              <p className="info"> */}
              {/* <ul>
                  <li>Custom Software Development</li>
                  <li>Cloud Engineering & DevOps</li>
                  <li>Product Design (UI/UX)</li>
                  <li>Data Analytics & AI Integration</li>
                  <li>IT Consulting & Digital Transformation</li>
                </ul> */}
              {/* </p>

              <p className="info-head">Why Work With Us?</p>
              <p className="info"> */}
              {/* <ul>
                  <li>Work on cutting-edge technologies</li>
                  <li>Exposure to global clients and projects</li>
                  <li>Fast-tracked career growth</li>
                  <li>Employee-first policies</li>
                  <li>Open-door leadership approach</li>
                </ul> */}
              {/* </p> */}
            </Row>

            <Row className=" p-3 m-4 mt-1 data">
              <p className="info-head">Roles & Responsibilities</p>
              <p className="info">
                {/* <ul>
                  <li>Develop user-facing features using React.js</li>
                  <li>
                    Collaborate with backend developers and designers to improve
                    usability
                  </li>
                  <li>Optimize applications for maximum speed</li>
                  <li>Maintain high-quality code and reusable components</li>
                  <li>Ensure technical feasibility of UI/UX designs</li>
                </ul> */}
                {fetchedTemplateData.rolesAndResponsibilities}
              </p>
            </Row>
            <Row className="  p-3 m-4 mt-1 data">
              <p className="info-head">Required Skills</p>
              <p className="info">{fetchedTemplateData.requiredSkills}</p>
            </Row>
            <Row className="  p-3 m-4 mt-1  data">
              <p className="info-head">Preferred Skills</p>
              <p className="info">{fetchedTemplateData.preferredSkills}</p>
            </Row>
            <Row className=" p-3 m-4 mt-1  data">
              <p className="info-head">Educational Qualifications</p>
              <p className="info">
                {fetchedTemplateData.educationalQualifications}
              </p>
            </Row>
            <Row className="  p-3 m-4 mt-1  data">
              <p className="info-head">Salary Range</p>
              <p className="info">{fetchedTemplateData.salaryRange}</p>
            </Row>
            <Row className="  p-3 m-4 mt-1  data">
              <p className="info-head">Interview Process</p>
              <p className="info">
                <ul>
                  {fetchedTemplateData?.interviewProcess.map((val) => (
                    <li>{val}</li>
                  ))}
                </ul>
              </p>
            </Row>
          </Row>
          {/* <Row className='' style={{ positon: "relative" }}>
                        <Col className='' style={{}}> <Button
                            style={{ backgroundColor: "#006438", color: "#FFFFFF", borderRadius: "12px", width: "160px", position: "absolute", right: "22px" }}

                        >
                            Download JD
                        </Button></Col>
                    </Row> */}
        </Row>
        <Row className="mt-3">
          <Col className="gap-2 d-flex justify-content-end">
            <Button
              className="text-primary border-primary me-5"
              style={{
                backgroundColor: "#FFFFFF",
                color: "#475467",
                borderRadius: "6px",
                border: "1px solid #475467",
              }}
              onClick={() => navigate("/template")}
            >
              Close
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ViewTemplate;
